namespace GeniuzPOS.ReportMasterData {
    export class Report_1101Columns {
        static columnsKey = 'ReportMasterData.Report_1101';
    }
}
